import {Handle, NodeProps, Position} from "reactflow";
import React from "react";
import "../css/smartTriggerProcessors.css"
import {SmartTriggerProcessorInputsBox} from "../../inputs/smartTriggerProcessorInputsBox";
import {ProcessorCard} from "../fragments/processorCard";
import {ProcessorHeader} from "../fragments/processorHeader";
import {ProcessorCardBody} from "../fragments/processorCardBody";
import {CalendarTime} from "tabler-icons-react";
import {Button} from "@mantine/core";

export function StartProcessorNodeComponent(props: NodeProps) {
    return (
        <>
            <ProcessorCard isSelected={props.selected}>
                <ProcessorHeader title="Smart Trigger Starts Here">
                    <Button radius={"sm"}
                            color={"gray"} rightIcon={<CalendarTime/>} size={"xs"} variant="outline">
                        Schedule
                    </Button>
                </ProcessorHeader>
                <hr className={"smart-trigger-divider"}/>
                <ProcessorCardBody
                    body={" \"This is the starting phase of your smart trigger. You can create the necessary inputs required\n" +
                    "                    for this smart trigger here\""}/>
                <SmartTriggerProcessorInputsBox nodeId={props.id}/>

            </ProcessorCard>
            <Handle type="source" position={Position.Bottom} id="a"/>
        </>
    );
}
